package com.downdogapp.client.controllers.playback

import com.downdogapp.*
import com.downdogapp.client.LogEmitter
import com.downdogapp.client.api.*
import com.downdogapp.client.currentClockTime
import com.downdogapp.client.singleton.Network
import com.downdogapp.client.singleton.Trackers

// record practice start, progress, and end
// also trackers, and say whether the practice lasted long enough to ask for a review
class ProgressController(private val sequence: Sequence,
                         private var getCurrentSequenceTime: () -> Duration,
                         private val isOffline: Boolean) : LogEmitter {

  private val startClockTime = currentClockTime()
  private var lastProgressRecordTime = currentClockTime()
  private var progressStartSequenceTime = currentSequenceTime
  private var totalTimePlayed = Duration.ZERO
  private var loggedPracticeEnd = false

  private val currentSequenceTime get() = getCurrentSequenceTime()

  init {
    Network.post(
      RecordPracticeStartedRequest(
        sequenceId = sequence.sequenceId,
        sequenceTime = currentSequenceTime,
        offline = isOffline
      )
    )
    logEvent("practice_started", mapOf("sequenceId" to sequence.sequenceId))
  }

  fun recordProgressIfNeeded() {
    if (currentClockTime() > lastProgressRecordTime + minutes(2)) {
      recordProgress()
    }
  }

  fun recordProgress(newSequenceTime: Duration = currentSequenceTime) {
    totalTimePlayed += currentSequenceTime - progressStartSequenceTime
    Network.post(
      RecordProgressRequest(
        sequenceId = sequence.sequenceId,
        sequenceStartTime = progressStartSequenceTime,
        sequenceEndTime = currentSequenceTime,
        offline = isOffline
      )
    )
    lastProgressRecordTime = currentClockTime()
    progressStartSequenceTime = newSequenceTime
  }

  // This will happen on sequence end reached, or on exiting if they exit early
  fun logPractice() {
    if (loggedPracticeEnd) {
      return
    }

    loggedPracticeEnd = true
    val duration = minOf(sequence.snapTimes.last(), getTotalTimePlayed())
    if (duration > Duration.ZERO) {
      Trackers.recordPractice(
        name = sequence.trackerLabel,
        activityType = sequence.activityType,
        startTime = startClockTime,
        duration = duration
      )
    }
    Network.post(
      RecordPracticeFinishedRequest(
        sequenceId = sequence.sequenceId,
        offline = isOffline
      )
    )
  }

  fun getTotalTimePlayed(): Duration = totalTimePlayed + currentSequenceTime - progressStartSequenceTime
}
